import React, { useState, useEffect } from 'react';
import './LandingPage.css'; 

const LandingPage = ({ onLoginClick }) => {
  // --- CAROUSEL MANTIĞI ---
  const [currentQuote, setCurrentQuote] = useState(0);

  const quotes = [
    {
      text: "Until you make the unconscious conscious, it will direct your life and you will call it fate.",
      author: "Carl Jung"
    },
    {
      text: "The unexamined life is not worth living.",
      author: "Socrates"
    },
    {
      text: "We are what we repeatedly do. Excellence, then, is not an act, but a habit.",
      author: "Aristotle"
    }
  ];

  // Her 6 saniyede bir otomatik geçiş yapar.
  // Kullanıcı oka veya noktaya basarsa (currentQuote değişirse) sayaç sıfırlanır.
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentQuote((prev) => (prev + 1) % quotes.length);
    }, 6000); 
    return () => clearInterval(interval);
  }, [currentQuote, quotes.length]);

  // Manuel geçiş fonksiyonları
  const handlePrev = () => {
    setCurrentQuote((prev) => (prev === 0 ? quotes.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentQuote((prev) => (prev + 1) % quotes.length);
  };

  return (
    <div className="landing-wrapper">
      
      {/* ÜST MENÜ */}
      <nav className="landing-nav">
        <div className="landing-brand">
            <span className="brand-icon">🏛️</span>
            <div className="brand-text">
                <div className="brand-title" style={{ letterSpacing: '3px', fontWeight: 'bold' }}>KAIROS</div>
                <div className="brand-subtitle" style={{ fontStyle: 'italic', letterSpacing: '1px' }}>YOURS, THE TIME IS.</div> 
            </div>
        </div>
        <button className="btn-vintage-outline" onClick={onLoginClick}>
            <i className="fa-solid fa-key" style={{marginRight: '8px'}}></i> Sign In
        </button>
      </nav>

      {/* ANA VİTRİN - MANUEL KONTROLLÜ CAROUSEL */}
      <div className="landing-hero">
        <div className="hero-content">
          
          {/* Sol Ok */}
          <button className="carousel-arrow left-arrow" onClick={handlePrev}>
            <i className="fa-solid fa-chevron-left"></i>
          </button>

          {/* Animasyonun her seferinde tetiklenmesi için "key" özelliği eklendi */}
          <div className="carousel-text-wrapper">
            <p key={`text-${currentQuote}`} className="quote-text" style={{ animation: 'fadeIn 0.8s ease-in-out' }}>
              "{quotes[currentQuote].text}"
            </p>
            <div key={`author-${currentQuote}`} className="quote-author" style={{ animation: 'fadeIn 0.8s ease-in-out' }}>
              — {quotes[currentQuote].author}
            </div>
          </div>

          {/* Sağ Ok */}
          <button className="carousel-arrow right-arrow" onClick={handleNext}>
            <i className="fa-solid fa-chevron-right"></i>
          </button>
          
          {/* Tıklanabilir Carousel Noktaları */}
          <div className="carousel-dots">
            {quotes.map((_, index) => (
              <div 
                key={index} 
                onClick={() => setCurrentQuote(index)}
                className={`carousel-dot ${currentQuote === index ? 'active' : ''}`}
              />
            ))}
          </div>

        </div>
      </div>

      {/* KAIROS SÖZLÜK TANIMI */}
      <div className="dictionary-definition" style={{ 
          maxWidth: '600px', 
          margin: '60px auto 40px auto', 
          textAlign: 'center',
          borderTop: '1px solid rgba(0,0,0,0.1)',
          borderBottom: '1px solid rgba(0,0,0,0.1)',
          padding: '20px 0',
          fontFamily: '"Georgia", serif',
          color: '#4a4a4a'
      }}>
          <h3 style={{ fontSize: '1.8rem', fontWeight: 'normal', margin: '0 0 5px 0', letterSpacing: '2px', color: '#2c2c2c' }}>
              kai·ros
          </h3>
          <p style={{ fontSize: '0.9rem', fontStyle: 'italic', margin: '0 0 15px 0', letterSpacing: '1px' }}>
              /ˈkīräs/ • Ancient Greek (καιρός)
          </p>
          <p style={{ fontSize: '1.1rem', fontStyle: 'italic', lineHeight: '1.6', margin: '0' }}>
              "The right, critical, or opportune moment. The fleeting instant when an opening appears which must be driven through with force if success is to be achieved."
          </p>
      </div>

      {/* FELSEFE / MANIFESTO */}
      <div className="philosophy-section" style={{ maxWidth: '900px' }}>
          <h2 className="section-header">THE MANIFESTO</h2>
          <p className="philosophy-text" style={{ textAlign: 'justify' }}>
              Our ultimate purpose is to make you act with consciousness. Algorithms are fundamentally designed to steal your time; they thrive when you move through the digital world unconsciously, letting the current drag you under. It is time to reclaim your awareness and live the life you truly desire. Make your own choices. Awaken. 
              <br/><br/>
              Are you genuinely aware of what is happening around you right now? When you have real people beside you and real potential within your reach, surrendering to an artificial space to chase illusions means you are only dreaming. You are living inside your head, not living your life. This platform was forged so you can experience life in reality. Retreating into your own mind should be your finest alternative only when no other choice remains—and even then, it must be done consciously. Act with intention.
              <br/><br/>
              <i>Kairos</i>—that critical moment—is right now. It is whenever you choose to catch the momentum. As long as you move with awareness, there is no need to rush. You no longer need cheap distractions to cope; instead, you grant yourself the time to pause, to rest, and to reflect. 
              <br/><br/>
              <b>KAIROS</b> is a tool and a reminder to help you live as your true self. And yes, this place is a headquarters. Our vision is for KAIROS to be an Enclave—a haven for those who have unplugged from the System. A gathering ground where you can rest, converse, and realize that you are not alone.
          </p>
      </div>

      {/* BİLGİ KARTLARI */}
      <div className="landing-features">
          <div style={{ textAlign: 'center', marginBottom: '15px' }}>
              <h2 className="section-header">THE KAIROS PROTOCOL</h2>
          </div>

          <div className="features-grid">
              <div className="feature-card">
                  <h3><i className="fa-solid fa-shield-halved"></i> Conscience Shield</h3>
                  <p>A browser extension acting as your personal guard. It blocks endless scrolling, filters out your defined 'triggers', and strictly enforces your leisure time.</p>
              </div>
              <div className="feature-card">
                  <h3><i className="fa-solid fa-chess-knight"></i> Real-World RPG</h3>
                  <p>Convert your daily habits and hard tasks into Experience Points (XP). Level up your core stats: Intelligence, Discipline, Vision, Energy, and Wealth.</p>
              </div>
              <div className="feature-card">
                  <h3><i className="fa-solid fa-chart-line"></i> The Codex</h3>
                  <p>Your unified command center. Visualize your growth velocity, plan your daily rituals, and maintain a private journal of your journey to greatness.</p>
              </div>
          </div>

          {/* Aksiyon Butonu */}
          <div style={{ textAlign: 'center', marginTop: '40px' }}>
              <button className="btn-initiation" onClick={onLoginClick}>
                AWAKEN
              </button>
          </div>
      </div>

      {/* ALT BİLGİ (Footer) */}
      <footer 
        className="landing-footer" 
        style={{ 
          textAlign: 'center', 
          width: '100%', 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center' 
        }}
      >
          <div>
              © 2026 KAIROS. All rights reserved.
          </div>
      </footer>
      
    </div>
  );
};

export default LandingPage;